import React from 'react';
import { useAuth } from '../context/AuthContext';

function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="page-card">
      <div className="dashboard-welcome">
        <h2>Welcome, {user?.fullName}!</h2>
        <p>
          {user?.role === 'SuperAdmin'
            ? 'You are logged in as Super Administrator. Use the side menu to manage tenants and monitor activities.'
            : user?.role === 'InstituteAdmin'
            ? `You are logged in as Institute Administrator${user?.tenantName ? ` for ${user.tenantName}` : ''}. Use the side menu to navigate.`
            : 'Select an option from the menu to get started.'}
        </p>
      </div>
    </div>
  );
}

export default Dashboard;
